module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo yellow-bg"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Faça seu acesso")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "ng-binding"
  }, [_vm._v("Alterar senha")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('novaSenha')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.novaSenha),
      expression: "form.novaSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    ref: "novaSenhaRef",
    staticClass: "form-control",
    class: {
      'input': true, 'is-danger': _vm.errors.has('novaSenha')
    },
    attrs: {
      "type": "password",
      "placeholder": "Digite a Senha",
      "name": "novaSenha",
      "data-vv-as": "nova senha",
      "vid": "novaSenha"
    },
    domProps: {
      "value": (_vm.form.novaSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "novaSenha", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('novaSenha')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('novaSenha')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    staticStyle: {
      "font-size": "smaller",
      "font-style": "italic"
    }
  }, [_vm._v("Pelo menos 6 caracteres (letras ou números)")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('confirmaSenha')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.confirmaSenha),
      expression: "form.confirmaSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:novaSenhaRef'),
      expression: "'required|confirmed:novaSenhaRef'"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'is-danger': _vm.errors.has('confirmaSenha')
    },
    attrs: {
      "type": "password",
      "placeholder": "confirme a senha",
      "data-vv-as": "confirma senha",
      "name": "confirmaSenha"
    },
    domProps: {
      "value": (_vm.form.confirmaSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmaSenha", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('confirmaSenha')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('confirmaSenha')))]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.fbb.org.br/projetos/portal",
      "target": "_"
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    }
  }, [_vm._v(" Antigo SGP")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Alterar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "white",
      "font-family": "verdana",
      "font-size": "73%"
    }
  }, [_vm._v("\n      * Observação: se você não foi informado pela FBB de que o seu projeto foi migrado para nova versão, basta acessar abaixo:\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bfabb64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlterarSenha.vue
// module id = 1855
// module chunks = 1